module.exports = __webpack_public_path__ + "img/5895deb9cba9841eabab6099.fb0c3a46.png";